import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Item } from 'src/app/models/item.model';
import { CompleteSiteNoteRequest, SiteNoteRequest, UpdateSiteNoteDto } from 'src/app/models/site-notes/site-note-request.model';
import { SiteNote } from 'src/app/models/site-notes/site-note.model';
import { ButtonIcons } from '../../action-button/models/button-icons.enum';
import { SiteNoteAddTemplateComponent } from '../site-note-add-template/site-note-add-template.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SiteNotesService } from 'src/app/services/sections/site-notes/site-notes.service';
import { FormGroup, FormControl } from '@angular/forms';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { SiteNoteUpdate } from 'src/app/models/site-notes/site-note-update.model';
import { Validators } from 'ngx-editor';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { ToastService } from 'src/app/services/ui/toast.service';
import { ToastType } from '../../toast/models/toast-type.enum';
import { AuthService } from 'src/app/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SiteNoteAssignee } from 'src/app/models/site-notes/site-note-assignee.model';

@Component({
	selector: 'site-note-completion',
	templateUrl: './site-note-completion.component.html',
	styleUrls: ['./site-note-completion.component.scss', '../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss', '../../stylesheets/job-inputs.scss']
})
export class SiteNoteCompletionComponent implements OnInit, AfterViewInit {
	@ViewChild('siteNoteAdd', { static: true }) public siteNoteAddTemplate: SiteNoteAddTemplateComponent;
	public self = this;

	public isLoading = false;
	public isVendor = false;

	public deficienciesUrl: string;
	public myWorkUrl: string;
	public siteNotesUrl: string;

	public siteNote: SiteNote;

	public completeNoteForm: FormGroup;

	public possibleAssignees: SiteNoteAssignee[] = [];

	public readonly ButtonIcons = ButtonIcons;
	public haveAccess: boolean | null = null;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private siteNotesService: SiteNotesService,
		private authService: AuthService) {
		this.siteNote = this.activatedRoute.snapshot.data.siteNote.data;
	}

	ngOnInit(): void {
		this.checkIfHaveAccess();
		this.initCompleteFormGroup();
	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			GlobalSettingsService.isGlobalLoaderLoading = false;
			
		}, 0);
	}

	private checkIfHaveAccess() {
		this.siteNotesService.isSiteNoteAccessibleByUser(TokenHelper.getToken(this.activatedRoute), this.siteNote?.siteNoteId).subscribe({
			next: (data: boolean) => {
				this.haveAccess = data;
				GlobalSettingsService.isSecondaryLoaderLoading = false;
			},
			error: (error: any) => {
				GlobalSettingsService.isSecondaryLoaderLoading = false;
			}
		});
	}

	public onBackClick(): void {
		this.router.navigate(['../'], { relativeTo: this.activatedRoute });
	}

	public onSaveClick(): void {
		this.isLoading = true;
		const siteNoteUpdate = {} as CompleteSiteNoteRequest;
		const formData = this.completeNoteForm.getRawValue();
		siteNoteUpdate.completionNote = formData.comment;

		this.siteNotesService.completeSiteNote(TokenHelper.getToken(this.activatedRoute), this.siteNote.siteNoteId, siteNoteUpdate).subscribe(res => {
			this.isLoading = false;
			this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
		}, (error: HttpErrorResponse) => {
			this.isLoading = false;
			if (error.status === 401) {
				ToastService.pushToast({
					text: 'Feature locked due to insufficient permissions!',
					icon: 'error',
					type: ToastType.Error
				});
			} else {
				ToastService.pushToast({
					text: 'Could not update Site Note. Please try again!',
					icon: 'error',
					type: ToastType.Error
				});
			}
		});
	}

	public initCompleteFormGroup(): void {
		this.completeNoteForm = new FormGroup({
			isComplete: new FormControl({ value: true, disabled: true }),
			comment: new FormControl(null, Validators.required())
		});
	}
}
